export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=00f485f071d1387984948eb9273e6aa6793ca56b33&name=fetchPublisherData!'